import React, { useState } from 'react';
import axios from 'axios';
import {
    Card,
    Grid,
    Button,
    TextField,
    makeStyles,
    Typography
} from '@material-ui/core/';
var shajs = require('sha.js')

const useStyles = makeStyles({
    loginModal: {
        padding: '8px',
        gap: '4px',
        width: '300px',
    }
})

type Admin = {
    username: string;
    password: string;
}

interface Props {
    API: string
}

type AdminVariant = 'username' | 'password';

function LoginModal({ API }: Props) {
    const classes = useStyles();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(false);

    function fetchAdmins() {
      return new Promise<Array<Admin>>( resolve => {
        axios.get(`${API}login`)
            .then( res => {
              resolve(res.data);
            })
            .catch(err => console.log(err));
        })
    };
    
    async function loadAdmin() {
        const hashedPass = shajs('sha256').update(password).digest('hex');
        const result = await fetchAdmins();
        const fetchedAdmin = {
            username: result[0].username,
            password: result[0].password,
        }

        if (username === fetchedAdmin.username && hashedPass === fetchedAdmin.password) {
            localStorage.setItem('admin', JSON.stringify(fetchedAdmin));
        } else {
            setError(true)
            return
        }

        window.location.reload();
    };

    const handleChange = (
        variant: AdminVariant, 
        event: string
    ) => {
        variant === 'username' && setUsername(event);
        variant === 'password' && setPassword(event);
        setError(false);
    }

    return (
        <Card>
            <Grid className={classes.loginModal} container direction='column'>
                <TextField type='text' placeholder='Přihlašovací jméno' value={username} onChange={(e) => handleChange('username', e.target.value)} />
                <TextField type='password' placeholder='Heslo' value={password} onChange={(e) => handleChange('password', e.target.value)}  />
                {error && <Typography color='error'>Špatné heslo nebo přihlašovací jméno</Typography>}
                <Grid container justify='center'>
                    <Button 
                        variant='contained' 
                        color='primary'
                        onClick={() => loadAdmin()}
                    >
                        Login
                    </Button>
                </Grid>
            </Grid>
        </Card>
    )
}

export default LoginModal;